<template>
    <v-col cols="12">
        <GravameEdit ref="editar" @close="response"></GravameEdit>
        <div>
            <core-grid
                ref="grid"
                :sort-by="['estado']"
                :sort-desc="[false]"
                :pageSize="-1"
                :onRead="onRead"
                :schema="schema"
                :addOption="false"
                :deleteOption="false"></core-grid>
        </div>
    </v-col>
</template>

<script>
import GravameEdit from './GravameEdit'
export default {
  components: {
    GravameEdit
  },
  data () {
    return {
      schema: [
        { text: 'Estado', value: 'estado' },
        { text: 'Sigla', value: 'uf', sortable: false },
        { text: 'Carros e Utilitários Pequenos', value: 'valorTipo1', format: 'currency', sortable: false },
        { text: 'Motos', value: 'valorTipo2', format: 'currency', sortable: false },
        { text: 'Caminhões e Micro-Ônibus', value: 'valorTipo3', format: 'currency', sortable: false }
      ]
    };
  },
  methods: {
    onRead: function (options) {
      this.$api.Kraken.GetAllGravames().then(function (response) {
        options.success(response)
      })
    },
    response (data) {
      if (data) { this.refresh() }
    },
    refresh () {
      this.$refs.grid.refresh()
    },
  },
};
</script>
